import { StrictMode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

import { initializeGtm } from './utils/analytics';
import { applyEarlyShareUrlSeo } from './utils/seo';

applyEarlyShareUrlSeo();

const Root = () => {
  useEffect(() => {
    initializeGtm();
  }, []);

  return (
    <StrictMode>
      <App />
    </StrictMode>
  );
};

createRoot(document.getElementById('root')!).render(<Root />);
